import React from 'react';
import { connect } from 'react-redux';
import ProductAmountSelections from './ProductAmountSelections';
import * as amountTrans from '../../translations/amount/amount_translations';

const Selections = (props) => {
  return (
    <div className="selectionsContainer">
        {props.amountSelection.map((selection) => {
          return (
        <div className="selectionContainer" key={selection.id}>
        <div className="titleContainer">
          <div className="title">
            <span className="titleText">{props.generalTranslations[selection.title] || selection.title}</span>
          </div>
          <div className="titleContent">
            <div className="titleText">
              {props.settings.locale === 'de-AT' ? amountTrans.at.chooseQuantity : amountTrans[props.settings.locale].chooseQuantity}
            </div>
            <div
              className="helpButton"
              onClick={() => props.toggleHelpAlert()}
              role="button"
              tabIndex="0"
              style={{ outline: 'none' }}
            >
              {props.generalTranslations.NeedHelp}

            </div>
          </div>
        </div>
          {selection.products
          .map(product => (<ProductAmountSelections
            key={product.id}
            productID={product.id}
            choicesID={product.choices_id}
            selectionID={props.selectionID}
            image={product.image}
            name={product.name}
            price={product.unit_gross_price}
            sizes={product.sizes}
            getSizeItem={props.getSizeItem}
            totalAmount={product.totalAmount}
            subgroupID={selection.id}
          />))}
        </div>
          );
      })}
    </div>
  );
};

const mapState = state => (
  {
    settings: state.settings,
    generalTranslations: state.generalTranslations,
  }
);

export default connect(mapState, null)(Selections);
